<template>
  <div class="ranking-filters">
    <div class="filters-left">
      <div class="filter-item">
        <label>Quadrimestre</label>

        <select
          :value="quadrimestre"
          @change="$emit('change-quadrimestre', $event.target.value)"
        >
          <!-- <option value=""></option> -->

          <option
            v-for="item in quadrimestres"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="filter-item">
        <label>Estado</label>

        <select
          :value="estado"
          @change="$emit('change-estado', $event.target.value)"
        >
          <option value=""></option>

          <option v-for="item in estados" :key="item.uf" :value="item.uf">
            {{ item.nome }}
          </option>
        </select>
      </div>

      <div class="filter-actions">
        <button class="btn-clear" @click="$emit('limpar')">Limpar</button>
      </div>
    </div>

    <!-- <div class="filters-right">
      <button class="btn-pdf" @click="$emit('gerar-pdf')">
        <i class="icofont-print"></i>
        PDF
      </button>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'RankingFilters',

  props: {
    estado: {
      type: String,
      default: '',
    },

    quadrimestre: {
      type: String,
      default: '',
    },

    quadrimestres: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      estados: [
        { uf: 'AC', nome: 'Acre' },
        { uf: 'AL', nome: 'Alagoas' },
        { uf: 'AP', nome: 'Amapá' },
        { uf: 'AM', nome: 'Amazonas' },
        { uf: 'BA', nome: 'Bahia' },
        { uf: 'CE', nome: 'Ceará' },
        { uf: 'DF', nome: 'Distrito Federal' },
        { uf: 'ES', nome: 'Espírito Santo' },
        { uf: 'GO', nome: 'Goiás' },
        { uf: 'MA', nome: 'Maranhão' },
        { uf: 'MT', nome: 'Mato Grosso' },
        { uf: 'MS', nome: 'Mato Grosso do Sul' },
        { uf: 'MG', nome: 'Minas Gerais' },
        { uf: 'PA', nome: 'Pará' },
        { uf: 'PB', nome: 'Paraíba' },
        { uf: 'PR', nome: 'Paraná' },
        { uf: 'PE', nome: 'Pernambuco' },
        { uf: 'PI', nome: 'Piauí' },
        { uf: 'RJ', nome: 'Rio de Janeiro' },
        { uf: 'RN', nome: 'Rio Grande do Norte' },
        { uf: 'RS', nome: 'Rio Grande do Sul' },
        { uf: 'RO', nome: 'Rondônia' },
        { uf: 'RR', nome: 'Roraima' },
        { uf: 'SC', nome: 'Santa Catarina' },
        { uf: 'SP', nome: 'São Paulo' },
        { uf: 'SE', nome: 'Sergipe' },
        { uf: 'TO', nome: 'Tocantins' },
      ],
    }
  },
}
</script>
<style scoped>
.ranking-filters {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filters-left {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.filters-right {
  margin-left: auto;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 240px;
}

.filter-item label {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 6px;
}

.filter-item select {
  height: 42px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 12px;
  outline: none;
  background: #ffffff;
}

.filter-actions button,
.btn-pdf {
  height: 42px;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  padding: 0 18px;
  cursor: pointer;
}

.btn-clear {
  background: #e5e7eb;
  color: #374151;
}

.btn-pdf {
  background: #16a34a;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-pdf:hover {
  background: #15803d;
}

@media (max-width: 768px) {
  .ranking-filters {
    align-items: stretch;
  }

  .filters-left,
  .filters-right {
    width: 100%;
  }

  .filter-item {
    width: 100%;
  }

  .filters-right {
    margin-left: 0;
  }

  .btn-pdf,
  .btn-clear {
    width: 100%;
    justify-content: center;
  }
}
</style>
